<template>
  <div class="summary" v-if="cart" @click="!checkDisabled && emit('submit')">
    <ul>
      <li>
        <span class="label">{{ $t('shopping.quickcart.deliverycosts') }} </span>
        <span v-html="cart?.shipping_cost" class="subtotal"></span>
      </li>
      <li v-if="cart?.wrapping !== 'standard'" >
        <span class="label">{{ $t('shopping.basket.checkout.gift_wrapping') }} </span>
        <span v-html="cart?.wrapping_cost" class="subtotal"></span>
      </li>
      <li v-if="cart.discount_number">
        <span class="label">{{ $t('my_account.orders.discount') }}</span>
        <span class="subtotal">{{ cart.discount }}</span>
      </li>
      <li>
      <span class="label">
        <span class="highlight">{{ $t('shopping.quickcart.total') }}</span> ({{ $t('shopping.quickcart.incl') }})
      </span>
        <span class="highlight">{{ cart.total_price }}</span>
      </li>
    </ul>
    <button
        type="button"
        name="submit"
        class="checkout-v2-btn"
        :disabled="checkDisabled"
        @click.stop="emit('submit')"
    >
      {{ isPurchaseStep ? isMobile ? $t('shopping.basket.checkout.payment_method') : $t('shopping.basket.checkout.purchase') : $t('shopping.quickcart.checkout') }}
    </button>
  </div>
</template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { isAdyenValid as isAdyenValidRef } from '@/composables/useAdyen'
import { useCheckout } from '@/app/Checkout/composables/useCheckout'
import { isMobile } from 'mobile-device-detect'

const { activePaymentMethod } = useCheckout()
const isAdyenValid = isAdyenValidRef

const props = defineProps({
  isPurchaseStep: { type: Boolean, default: false },
})

const checkDisabled = computed(() => {
  return props.isPurchaseStep && activePaymentMethod.value === 32 && isAdyenValid.value === false
})

const store = useStore()
const cart = computed(() => store.state.cart.cart)

const emit = defineEmits(['submit'])

</script>
